import { Option } from '@components/FormInput/types';
import React from 'react';
import { ControlProps, components } from 'react-select';

const CustomControl = (props: ControlProps<Option, false>) => {
  return (
    <div data-testid={`${props.selectProps.inputId}-control`}>
      <components.Control {...props}>
        {props.selectProps.prefix && (
          <div className="flex-none" style={{ paddingRight: 8 }}>
            {props.selectProps.prefix}
          </div>
        )}
        {props.children}
      </components.Control>
    </div>
  );
};

export default CustomControl;
